
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { isKeyframesTarget } from '../animation/utils/is-keyframes-target.mjs.js';

var isCustomValue = function (v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function (v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

export { isCustomValue, resolveFinalValueInKeyframes };
//# sourceMappingURL=resolve-value.mjs.js.map
